var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scoring-component"},[_c('div',{staticClass:"score-numbers"},_vm._l((_vm.scoreRange),function(num){return _c('div',{key:num,staticClass:"number-item",class:{ active: _vm.value === num, disabled: _vm.disabled },on:{"click":function($event){return _vm.handleSelect(num)}}},[_vm._v(" "+_vm._s(num)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }